import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import UserLayout from "layouts/user";
import PublicLayout from "layouts/public";
import ProtectedRoute from "components/ProtectedRoute";
import { ToastProvider } from "components/Toast";

const App = () => {
  const AnnounceRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`/user/announcements/${id ?? ""}`} replace />;
  };
  const AnnounceIndexRedirect = () => (
    <Navigate to="/user/announcements" replace />
  );
  const EventRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`/user/events/${id ?? ""}`} replace />;
  };
  const EventIndexRedirect = () => <Navigate to="/user/events" replace />;

  return (
    <ParallaxProvider>
      <ToastProvider>
        <Routes>
          {/* Public short URLs redirect to user panel routes */}
          <Route path="announcements" element={<AnnounceIndexRedirect />} />
          <Route path="announcements/:id" element={<AnnounceRedirect />} />
          <Route path="events" element={<EventIndexRedirect />} />
          <Route path="events/:id" element={<EventRedirect />} />
          <Route path="auth/*" element={<AuthLayout />} />
          <Route path="/*" element={<PublicLayout />} />
          <Route
            path="admin/*"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          />
          <Route path="user/*" element={<UserLayout />} />
          <Route path="rtl/*" element={<RtlLayout />} />
          <Route path="/" element={<Navigate to="/home" replace />} />
        </Routes>
      </ToastProvider>
    </ParallaxProvider>
  );
};

export default App;
